export * from './fond-delete-request.interface';
export * from './fond-delete-response.interface';
export * from './fond-delete.shapes';
